import React from 'react';
import Fade from 'react-reveal/Fade';
import './style.css';

const Navbar = (props) => {
    return (
      <header className="header-container fixed z-999 w-100 flex flex-row">
        <Fade top cascade>
          <div className="main-title w-60 ma0 pa0"> Giorgyg </div>
        </Fade>
        <a className="main-shop-button" href="/shop/icons"> Shop </a>
      </header>
    )
}

export default Navbar



// WEBPACK FOOTER //
// ./src/general/Navbar/index.jsx